import { styled } from "../../../../../../styles";

export const RagIndicatorContainer = styled("div", {
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  lineHeight: 1,
});

export const RagCircle = styled("span", {
  display: "inline-block",
  width: "14px",
  height: "14px",
  borderRadius: "50%",
  flexShrink: 0,
});

export const TrendArrow = styled("span", {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  lineHeight: 0,
  marginLeft: "4px",

  svg: {
    width: "14px",
    height: "14px",
  },
});

export const RagValue = styled("span", {
  fontFamily: "'Open Sans', sans-serif",
});
